import { createFileRoute } from '@tanstack/react-router';

import { Heading } from '@/common/components/heading';
import { Seo } from '@/common/components/seo';
import { requireAuth } from '@/shared/auth';

export const Route = createFileRoute('/settings')({
  beforeLoad: ({ location, context }) => {
    requireAuth({ location, auth: context.auth });
  },
  component: SettingsRoute
});

function SettingsRoute() {
  return (
    <>
      <Seo title="Settings" />
      <div className="flex w-full flex-wrap items-end justify-between gap-4 border-b border-zinc-950/10 pb-6 dark:border-white/10">
        <Heading>Settings</Heading>
      </div>
    </>
  );
}
